export default __webpack_public_path__ + "static/media/0x4e78011ce80ee02d2c3e649fb657e45898257815.3772aad2.webp";